'use strict';

order.$inject = ["Totals", "OrderProduct", "Address", "Enums", "gettextCatalog"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.order = order;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function order(Totals, OrderProduct, Address, Enums, gettextCatalog) {
    var clazz = function Order() {
        var defaults = {
            id: 0,
            referenceNumber: '',
            orderNumber: '',
            date: '',
            sellerName: '',
            wholeSalerName: '',
            orderStatusCode: '',
            isPartialStatus: false,
            orderStatusText: '',
            hasError: false,
            hasSuccess: false,
            customerNumber: '',
            APBNr: '',
            deliveryAddress: null,
            invoiceAddress: null,
            totals: null,
            products: null,
            shippingNotes: null,
            version: 0,
            note: null,
            originalOrderId: 0,
            originalOrderReference: 0,
            actualDeliveryDate: null,
            deliveryRouteNumber: null
            //deliveries: null
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {
        setDeliveries: function setDeliveries(deliveries) {
            this.deliveries = deliveries;
        }
    });

    clazz.create = function (resource) {
        var o = new clazz();
        o.id = resource.id;
        o.referenceNumber = resource.referenceNr;
        o.orderNumber = resource.orderNr;
        o.date = resource.orderDate;
        o.sellerName = resource.sellerName;
        o.wholesalerName = resource.wholeSalerName;
        o.orderStatusCode = resource.stateCode;
        o.isPartialStatus = resource.isPartialState;
        o.orderStatusText = orderStatusText(resource.stateCode);
        o.hasError = hasError(resource.stateCode);
        o.hasSuccess = hasSuccess(resource.stateCode);
        o.customerNumber = resource.febelcoCustomerNr;
        o.APBNr = resource.apbNumber;
        o.deliveryAddress = resource.deliveryAddress ? Address.create(resource.deliveryAddress) : null;
        o.invoiceAddress = resource.invoiceAddress ? Address.create(resource.invoiceAddress) : null;
        o.totals = Totals.create(resource);
        o.products = _lodash2.default.map(resource.orderProducts, function (i) {
            return OrderProduct.create(i);
        });
        o.shippingNotes = resource.shippingNotes;
        o.deliveryDate = resource.deliveryDate;
        o.version = resource.version;
        o.note = resource.note;
        o.originalOrderId = resource.originalOrderId;
        o.originalOrderReference = resource.originalOrderReference;
        o.groupedProducts = _lodash2.default.groupBy(o.products, 'productNumber');
        o.actualDeliveryDate = resource.actualDeliveryDate;
        o.deliveryRouteNumber = resource.deliveryRouteNumber;
        //o.deliveries = lodash.map(resource.Deliveries, i => Delivery.create(i));
        return o;
    };

    function orderStatusText(code) {
        return code ? gettextCatalog.getString(Enums.orderStatusTexts[code].text) : '';
    }

    function hasError(code) {
        return code ? code === 'ERROR' || code === 'CANCELLED' : false;
    }

    function hasSuccess(code) {
        return code ? code === 'READYWS' || code === 'INVWS' || code === 'INVWSP' : false;
    }

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/orderModel.js
// module id = 763
// module chunks = 0